export default __webpack_public_path__ + "static/media/a028-4.fe137fc9.svg";